import { gql } from '@apollo/client';

export const CREATE_TWITTER_AD_INTEGRATION = gql`
  mutation CreateTwitterAdIntegration(
    $request: CreateTwitterAdIntegrationRequest!
  ) {
    CreateTwitterAdIntegration(request: $request) {
      id
      socmed_adset_id
    }
  }
`;

export const UPDATE_TWITTER_AD_INTEGRATION_BY_ID = gql`
  mutation UpdateTwitterAdIntegration(
    $id: String!
    $request: UpdateTwitterAdIntegrationRequest!
  ) {
    UpdateTwitterAdIntegration(id: $id, request: $request) {
      id
    }
  }
`;
